module.exports = __webpack_public_path__ + "img/goast_half.b435c56c.svg";